import { render, staticRenderFns } from "./EnsDeclaration.vue?vue&type=template&id=fe2525aa&"
import script from "./EnsDeclaration.vue?vue&type=script&lang=js&"
export * from "./EnsDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports